import { Loader, Send, X } from "lucide-react";
import React, { useRef, useState } from "react";
import Spacing from "../Spacing";
import Grid from "../Grid";
import Select from "react-select";
import { Drawer } from 'vaul';


const allFeatureTypes = [
  { value: "AI Charting", label: "Ai Charting" },
  { value: "Annual Wellness", label: "Annual Wellness" },
  { value: "Appointment", label: "Appointment" },
  { value: "Average payment per encounter", label: "Average payment per encounter" },
  { value: "Billing", label: "Billing" },
  { value: "CareGap Plus", label: "CareGap Plus" },
  { value: "Credits", label: "Credits" },
  { value: "Change Password", label: "Change Password" },
  { value: "Chart Claim Submitted", label: "Chart Claim Submitted" },
  { value: "Chart Payment Received", label: "Chart Payment Received" },
  { value: "Easy Referral", label: "Easy Referral" },
  { value: "Forms", label: "Forms" },
  { value: "Haven't Visited In This Year", label: "Haven't Visited In This Year" },
  { value: "High-Risk Patients", label: "High-Risk Patients" },
  { value: "Imaging Orders", label: "Imaging Orders" },
  { value: "Invited Users", label: "Invited Users" },
  { value: "Lab Report f/u Missed", label: "Lab Report f/u Missed" },
  { value: "Letter", label: "Letter" },
  { value: "Message", label: "Message" },
  { value: "Patient Database", label: "Patient Database" },
  { value: "Rejection Tracker", label: "Rejection Tracker" },
  { value: "Review", label: "Review" },
  { value: "Scheduler Setting", label: "Scheduler Setting" },
  { value: "Settings", label: "Settings" },
  { value: "Shoutbox", label: "Shoutbox" },
  { value: "Users", label: "Users" },
  { value: "Waiting Room", label: "Waiting Room" }
];

export default function SupportModal(props) {
  const { open, closeDialog, handleSubmit,formData,setFormData,loading } = props;
  const [impactData, setImpactData] = useState("");
  const dropdownRef = useRef(null);

  const handleImpactChange = (selectedOption) => {
    setImpactData(selectedOption?.value);
    setFormData({ ...formData, impact: selectedOption?.value || "" });
  };

  const handleSelectFeature = (selectedOption) => {
    setFormData({ ...formData, feature_type: selectedOption?.value || "" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };


  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={open} onOpenChange={closeDialog}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">Add User</Drawer.Title>
            <Drawer.Description className="sr-only">Add a new user</Drawer.Description>
            <div className="docpro_modal_wrap docpro_modal_lg center">
              <div className="docpro_modal">
                <h2 className="docpro_fs_24">Send Support Message</h2>

                <form onSubmit={handleSubmit}>
                  <Grid variant="docpro_grid_gap_20 docpro_grid_col_2">
                    <div className="docpro_card_1">
                      <label className="docpro_fw_500 docpro_primary_color">
                        CC (optional)
                      </label>
                      <input
                        type="email"
                        className="docpro_form_field size_lg"
                        name='cc_mail'
                        defaultValue={setFormData.cc_mail || ""}
                        onChange={handleChange}
                        placeholder="Add email"
                      />
                    </div>

                    <div className="docpro_card_1">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Impact <span className="docpro_red_color">*</span>
                      </label>
                      <Select
                        required
                        name="impact"
                        options={[
                          { value: "General Issue", label: "General Issue" },
                          { value: "Degraded Service", label: "Degraded Service" },
                          { value: "Business Critical", label: "Business Critical" }
                        ]}
                        placeholder="Search..."
                        isSearchable
                        value={impactData ? { value: impactData, label: impactData } : null}
                        onChange={handleImpactChange}
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        filterOption={(option, rawInput) => {
                          const words = rawInput.toLowerCase().split(" ");
                          return words.every((word) =>
                            option.label.toLowerCase().includes(word)
                          );
                        }}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '40px',
                            borderColor: 'var(--border)',
                            borderRadius: '8px'
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 1050,
                            marginTop: '-2px',
                            borderRadius: '0 0 3px 3px',
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 1050,
                            padding: 0
                          }),
                        }}
                      />
                    </div>
                  </Grid>
                  <Spacing lg="20" sm="20" />

                  <p className='docpro_mb_0'>
                    <b>General Issue:</b> All other issues not amounting to Business Critical or Degraded Service. These include, but are not limited to, non-critical technical issues, product "how-to" questions, implementation questions, and feature requests.
                    <br /><br />
                    <b>Degraded Service:</b> Issues involving partial failure or mild degradation of the Services. You are able to access some, but not all, Service features.
                    <br /><br />
                    <b>Business Critical:</b> Issues involving total failure or severe degradation of the Services. You are unable to access the Services.
                  </p>
                  <Spacing lg="20" sm="20" />

                  <Grid variant="docpro_grid_gap_20 docpro_grid_col_2">
                    <div className="docpro_card_1">
                      <label className="docpro_fw_500 docpro_primary_color">Feature type <span className="docpro_red_color">*</span></label>
                      <Select
                        required
                        name="impact"
                        options={allFeatureTypes}
                        placeholder="Search..."
                        isSearchable
                        value={allFeatureTypes.find((option) => option?.value === formData.feature_type) || null}
                        onChange={handleSelectFeature}
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        filterOption={(option, rawInput) => {
                          const words = rawInput.toLowerCase().split(" ");
                          return words.every((word) =>
                            option.label.toLowerCase().includes(word)
                          );
                        }}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '40px',
                            borderColor: 'var(--border)',
                            borderRadius: '8px'
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 1050,
                            marginTop: '-2px',
                            borderRadius: '0 0 3px 3px',
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 1050,
                            padding: 0
                          }),
                        }}
                      />
                    </div>

                    <div className="docpro_card_1">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Subject <span className="docpro_red_color">*</span>
                      </label>
                      <input 
                        required
                        type="text"
                        className="docpro_form_field size_lg"
                        name='subject'
                        defaultValue={setFormData.subject}
                        onChange={handleChange}
                      />
                    </div>
                  </Grid>
                  <Spacing lg="20" sm="20" />

                  <label className="docpro_fw_500 docpro_primary_color">
                    What’s the issue? <span className="docpro_red_color">*</span>
                  </label>
                  <textarea
                    required
                    rows="5"
                    cols="6"
                    className="docpro_form_field size_lg"
                    name='issue'
                    defaultValue={setFormData.issue}
                    onChange={handleChange}
                  ></textarea>
                  <Spacing lg="30" sm="30" />
                  
                  {/* <div className="">

                    <button
                      type='submit'
                      className={`docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg`}
                      disabled = {loading ? true : false}
                    >
                      <Send width={20} height={20} />
                      <span>Send</span>
                      {loading && (
                        <span className="docpro_loading">
                          <Loader width={18} height={18} />
                        </span>
                      )}
                    </button>
                  </div> */}
                  <div className="docpro_modal_btns small_buttons docpro_mt_auto">
                    <button
                      className="docpro_bordered_btn docpro_fw_600 size_lg"
                      onClick={closeDialog}
                    >
                      Cancel
                    </button>
                    <button
                      type='submit'
                      className={`docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg`}
                      disabled = {loading ? true : false}
                    >
                      <Send width={20} height={20} />
                      <span>Send</span>
                      {loading && (
                        <span className="docpro_loading">
                          <Loader width={18} height={18} />
                        </span>
                      )}
                    </button>           

                  </div>
                  
                </form>
                
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
